import React from 'react';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Grid } from 'fw/forms';
import { Button } from 'fw/components';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import { Col, Row } from 'react-bootstrap';
import SponsorTypeInfo from './SponsorTypeInfo';
import * as FormManager from 'fw/forms/form/FormManager'
import * as App from 'modules/app/App';


const columns = [
    { key: 'sponsorTypeCode', name: 'Sponsor Type Code', width: 150 },
    { key: 'description', name: 'Description', width: 500 },
];

class SponsorTypeSetup extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = (props) => {
        return {
            rows: [],
            sponsorTypeCode: null,
			newSponsorType: null
        };
    }

    componentDidMount() {
        this.search();
    }

    resetSponsorType = () => {
        this.setState({ 
			sponsorTypeCode: null,
			newSponsorType: null
		 });
    }

    search = (callback) => {
        let me = this;

        new API().post(APIModules.App.url('/sponsorTypeSetup/getSponsorTypes'), null,
            {
                success: (r) => {
                    let rows = r.data.items;

                    // Store search results
                    this.setState({ 
                        title: r.data.title,
                        rows: rows
                    }, me.resetSponsorType());
                }
            });
    }

    goToSponsorTypeDetails = () => {
        setTimeout(() => {
            window.scrollTo({
                behavior: "smooth",
                top: this._sponsorTypeDetail.offsetTop
            });
        }, 200);
    }

    onEditSponsorType = (sponsorTypeCode) => {
        FormManager.checkUnsavedChanges(() => {
            this.setState({ 
				sponsorTypeCode: sponsorTypeCode,
				newSponsorType: false
			}, () => { this.goToSponsorTypeDetails() });
        });
    }

    handleSponsorTypeUpdate = () => {
        this.search();
    }

    handleSponsorTypeCancel = () => {
        this.resetSponsorType();
    }

    handleAddSponsorType = () => {
		FormManager.checkUnsavedChanges(() => {
       		this.setState({ 
				sponsorTypeCode: "",
				newSponsorType: true
			}, () => { this.goToSponsorTypeDetails() });
		})
    }

    render() {
        return (
            <React.Fragment>
                <ContentHeader title={`Sponsor Type `} description=" Create, modify, and remove Sponsor Types" >
                    <Button id="btnAddNew" bsStyle="success" className="pull-right" style={{ marginRight: 0 }}
                        onClick={this.handleAddSponsorType} disabled={!App.hasPrivilege("AdminSponsorTypeSetupAdd") || this.state.sponsorTypeCode !== null}>Add New Sponsor Type</Button>
                </ContentHeader>
                <ContentBody> 
                    <Row>
                        <Col md={5}>
                            <Grid
                                ref={(c) => { this._grid = c }}
                                columns={columns}
                                items={this.state.rows}
                                height={250}
                                className="table-condensed"
                                rowKey="sponsorTypeCode"
                                onChange={this.onEditSponsorType}
                                name="default" />
                        </Col>
                    </Row>
                    <div ref={(c) => { this._sponsorTypeDetail = c }}>
                    </div>
                    {this.state.sponsorTypeCode !== null &&
                        <React.Fragment>
                            <Row>
                                <Col md={12}>
                                    { <SponsorTypeInfo
                                        sponsorId={this.props.selectedId}
                                        sponsorTypeCode={this.state.sponsorTypeCode}
										newSponsorType={this.state.newSponsorType}
                                        onUpdate={this.handleSponsorTypeUpdate}
                                        onCancel={this.handleSponsorTypeCancel}
                                    /> }
                                </Col>
                            </Row>
                        </React.Fragment>
                    }
                </ContentBody>
            </React.Fragment>
        )
    }
}

export default SponsorTypeSetup;


// WEBPACK FOOTER //
// ./src/areas/admin/sponsorTypeSetup/SponsorTypeSetup.js